<template>
    <div>
        <div class="card-body">
            <table class="table" v-loading="$parentInfo.studentWallet.dialog_LessonRetired.loading">
                <thead>
                <tr>
                    <th>年级</th>
                    <th>学科</th>
                    <th>班型</th>
                    <th>剩余课时</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in orderStudentLessons" :key="item.id">
                    <td>{{item.grade.name}}</td>
                    <td>{{item.subject.name}}</td>
                    <td>{{item.class_type.name}}</td>
                    <td>{{item.period}}</td>
                    <td>
                        <el-button type="primary" :disabled="item.period<=0"
                                   @click="handleUpdateStudentPeriod(item.id)"
                                   :loading="$parentInfo.studentWallet.dialog_LessonRetired.button_loading">退费
                        </el-button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_LessonRetired',
        data() {
            return {
            };
        },
        computed: {
            orderStudentLessons: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.dialog_LessonRetired.studentLessons, 'id', 'desc');
            },
        },
        mounted() {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentWallet.dialog_LessonRetired.loading = true;
            this.handleGetLesson();
        },
        methods: {
            // 查找相同课程下班级信息
            handleGetLesson() {
                this.$wApi.send(this.$parentInfo.path, 'getLessonInWallet', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleUpdateStudentPeriod(studentPeriod_id) {
                this.$parentInfo.studentWallet.dialog_LessonRetired.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'cancelRetirePeriod', {
                    'studentPeriod_id': studentPeriod_id,
                    'student_id': this.$parentInfo.student_id,
                });
            },

        }
    };
</script>

<style scoped>

</style>
